module.exports = __webpack_public_path__ + "img/電気回路_1_6_4.ecddb986.png";